<template>
  <div>
    <transition v-if="wish" name="modal" appear>
      <div class="cartMsg" id="cartMsg">
        <div class="inner">
          <div class="msgR">
            <img src="@/../static/img/mw/content/icon_heart.png" />
            <p class="tit">{{ msg }}</p>
          </div>
        </div>
      </div>
    </transition>
    <!-- <ConfirmPop
      v-if="confirmPop"
      @confirm="$router.push({ name: 'login', params: { redirect: $route.name, param: $route.params } })"
      @cancel="confirmPop = false"
      @close="confirmPop = false"
    >
      <p v-html="popMsg"></p>
    </ConfirmPop> -->
    <ProgressBar ref="progress"></ProgressBar>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
// import ConfirmPop from '@/components/popup/ConfirmPop';
import ProgressBar from '@/views/app/comm/ProgressBar';
//import { LOGIN_FUNCTION_REQUIRE } from '@/store/message.type';
// import $ from 'jquery';
export default {
  name: 'UpdateWishList',
  // props: ['p_flag'],
  // ConfirmPop
  components: { ProgressBar },
  data() {
    return {
      msg: '',
      popMsg: '',
      wish: false,
      confirmPop: false,
    };
  },
  // mounted() {
  //   console.log(this.$route.params);
  // },
  methods: {
    updateWishList(product) {
      let token = JwtService.getToken();

      if (!token) {
        // TODO 로그인 팝업 확인필요
        //this.popMsg = LOGIN_FUNCTION_REQUIRE;
        //this.confirmPop = true;
        this.$router.push({ name: 'login', params: { redirect: this.$route.name, param: this.$route.params } });
      } else {
        this.$refs.progress.loadingStart();
        if (product.wishItem == true) {
          // 찜 삭제
          ApiService.service('DELETE', '/product/auth/wishlist/product', {
            request: {
              productIndex: product.productIndex,
            },
            serviceType: 'app',
          })
            .then(({ data }) => {
              console.log(data);
              if (data.isSucceed) {
                this.$emit('updateWishCount', product, false, -1);
                this.msg = '찜 해제';
                this.wish = true;
                setTimeout(() => {
                  this.wish = false;
                }, 500);
              }
            })
            .catch(({ response }) => {
              console.log('error : ' + response);
            });
        } else {
          // 찜 하기
          ApiService.service('POST', '/product/auth/wishlist/product', {
            request: {
              productIndex: product.productIndex,
            },
            serviceType: 'app',
          })
            .then(({ data }) => {
              console.log(data);
              if (data.isSucceed) {
                this.$emit('updateWishCount', product, true, 1);
                this.msg = '찜 성공';
                this.wish = true;
                setTimeout(() => {
                  this.wish = false;
                }, 500);
              }
            })
            .catch(({ response }) => {
              console.log('error : ' + response);
            });
        }
        this.$refs.progress.loadingEnd();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.6s;
}

.modal-leave-active {
  transition: opacity 0.6s ease 0.6s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
}
</style>
